<template>
  <v-snackbar
    v-model="snackbar.show"
    :timeout="snackbar.timeout"
    :color="snackbar.color"
  >
    {{ snackbar.message }}
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      snackbar: {
        show: false,
        message: "",
        color: "success",
        timeout: 3000,
      },
    };
  },
  created() {
    this.$root.$on("show-snackbar", this.showSnackbar);
  },
  methods: {
    showSnackbar({ message, color = "success", timeout = 3000, error_info }) {
      let msg = this.$t(message);
      if (error_info) {
        Object.keys(error_info).forEach((key) => {
          msg = msg.replace(`{${key}}`, error_info[key]);
        });
      }
      this.snackbar = { show: true, message: msg, color, timeout };
    },
  },
};
</script>
